import autobind from 'autobind-decorator';

import { Input, OnInit } from '@angular/core';
import { FormBuilder, ValidationErrors } from '@angular/forms';

import { AtxGenericFormComponent } from '../../generic-form';

export abstract class AtxBehaviorSubjectFormComponent extends AtxGenericFormComponent implements OnInit {
    @Input() public readonly model;

    constructor(
        private readonly _service,
        private readonly _fb: FormBuilder,
        private readonly _controlsConfig: ValidationErrors,
    ) {
        super(_fb, _controlsConfig);
    }

    public ngOnInit() {
        super.ngOnInit();

        if (Object.keys(this.model).length) {
            this.form.setValue({ ...this.form.value, ...this.model });
        }

        this.form.valueChanges.subscribe(this.onChange);
    }

    public patchValue = (name) => (value) => {
        if (this.form.get(name).value !== value) {
            this.form.patchValue({ [name]: value[name] || value });
        }
    };

    public mergeValue = (data) => {
        this.form.patchValue({ ...this.form.value, ...data });
    };

    @autobind
    public onChange() {
        if (this.form.valid) {
            this._service.setModel(this.form.value);
        }
    }
}
